import React, {useMemo} from 'react';

import {AlertItem} from './alert-item';

import type {McpContract} from 'src/openapi/admin/models/McpContract';
import type {McpCreditAlertInfo} from 'src/openapi/admin/models/McpCreditAlertInfo';

type Props = {
    data: Array<McpCreditAlertInfo>,
    onRemove: (contractId: number, value: number, type: 'credits' | 'overages') => void,
    contracts: Array<McpContract>,
    disabled?: boolean,
};

export const AlertsList = ({data, onRemove, contracts, disabled}: Props) => {
    const contractsMapping = useMemo(() =>
        contracts.reduce((memo, contract) => {
            memo[contract.contractId] = contract.contractNumber;
            return memo;
        }, {} as Record<number, string>), [contracts]);

    return (
        <>
            {data.flatMap(item => {
                const rowCount = Math.max(
                    item.creditsBelow.length,
                    item.overagesBelow.length,
                );
                return Array.from({length: rowCount}, (_, i) => (
                    <AlertItem
                        key={`${item.contractId}-${i}`}
                        showCaption={i === 0}
                        contractNumber={contractsMapping[item.contractId]}
                        contractId={item.contractId}
                        creditValue={item.creditsBelow[i]}
                        overageValue={item.overagesBelow[i]}
                        onRemove={onRemove}
                        disabled={disabled}
                    />
                ));
            })}
        </>
    );
};
